import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToAnchor = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;

    const targetId = location.hash.slice(1);

    const scrollToElement = (element: HTMLElement) => {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      scrollToElement(targetElement);
      return;
    }

    const observer = new MutationObserver(() => {
      const element = document.getElementById(targetId);
      if (element) {
        scrollToElement(element);
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, [location]);

  return null;
};
